<template>
  <div class="border border-solid rounded-lg p-2">
    <div class="flex flex-row items-center gap-3 mb-1">
      <p class="text-lg mb-0">
        {{ data.title }}
      </p>
      <img
        v-b-tooltip.hover.top="{
          title: data.tooltip,
          customClass: 'dark-tooltip left-text-tooltip'
        }"
        src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
        alt="Komerce"
        class="size-[17px]"
      >
    </div>
    <div class="flex items-center gap-[.5rem]">
      <h4 class="text-black font-semibold text-2xl mb-0">
        {{ data.count }}
      </h4>
      <div
        v-if="data.growth"
        class="flex items-center gap-[.25rem] rounded-full px-[.75rem] py-[.25rem]"
        :class="isGrowthUp ? 'bg-[#E6F6EB] text-[#30A46C]' : 'bg-[#FEF2F2] text-[#E31A1A]'"
      >
        <span
          class="me-[.25rem]"
          :class="isGrowthUp ? 'triangle-up' : 'triangle-down'"
        />
        <span>{{ data.growth }}%</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.triangle-up {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 10px solid #30A46C;
}
.triangle-down {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 10px solid #e31a1a;
}
.bg-[\#E6F6EB] {
  background-color: #E6F6EB;
}
.bg-[\#FEF2F2] {
  background-color: #FEF2F2;
}
.text-[\#30A46C] {
  color: #30A46C;
}
.text-[\#E31A1A] {
  color: #E31A1A;
}
</style>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({
        title: '',
        tooltip: '',
        count: '',
        growth: '',
      }),
    },
  },
  computed: {
    isGrowthUp() {
      return this.data.growth > 0
    },
  },
}
</script>
